import { getConfig } from "@jti/fe-common";
import { getIsEvo, getUser } from "../../utils";
import { DeviceApiEvo } from "./DeviceApiEvo";
import { DeviceApiLegacy } from "./DeviceApiLegacy";
export class DeviceApi {
    static init(jwtToken) {
        const config = getConfig();
        const user = getUser();
        if (getIsEvo(config.DES_DEVICE_SERVICE_URL)) {
            return new DeviceApiEvo(config.DES_DEVICE_SERVICE_URL, config.DIS_DES_AK_TENANT_TOKEN, config["X-RECAPTCHA-ID"], user.ciam_token, jwtToken);
        }
        return new DeviceApiLegacy(config.DES_DEVICE_SERVICE_URL, config.DIS_DES_AK_TENANT_TOKEN, user.ciam_token, jwtToken);
    }
}
//# sourceMappingURL=DeviceApi.js.map